<template>
    <div class="mt--2 mb-4 heading-small card-stepper">
        <div class="card-stepper-wrapper">
            <div v-for="(item, key) in items" :key="key" :class="navigationClass(item)">
                <div class="content-wrapper text-capitalize">
                    <div class="mb-1">
                        <span class="numeric-bullet mr-2" v-text="key + 1"></span>
                    </div>
                    {{ item.title }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "CardNavigation",

    methods: {
        getDisplayName(name) {
            return name ? name.replace("_", " ") : "";
        },
        
        navigationClass(item) {
            return item.id == this.activeItem.id ? "card-stepper-item active" : "card-stepper-item";
        }
    },

    props: {
        items: Array,
        activeItem: Object,
    }
}
</script>
<style lang="css" scoped>
    .card-stepper-wrapper {
        display: flex;
        flex-direction: row;
    }
    .card-stepper-nav::before {
        content: " ";
        display: block;
        z-index: 1;
        border: 1px solid #b5b6b7;
        border-width: 1px 0 0 0;
        top: 9px;
        position: relative;
    }
    .card-stepper-item {
        color: #555555 !important;
        z-index: 5;
        flex: 1;
        text-align: center;
    }
    .card-stepper-item:not(.active) {
        color: #b5b6b7 !important;
    }
    .card-stepper-item .numeric-bullet {
        border-radius: 50%;
        color: #f5f6f8;
        background-color: #555555;
        padding: 0px 5px;
        display: inline-block;
        font-weight: 500;
    }
    .card-stepper-item:not(.active) .numeric-bullet {
        background-color: #b5b6b7 !important;
    }
    .card-stepper-item .content-wrapper {
        padding: 0px 5px;
        background-color: #f5f6f8;
        display: inline-block;
    }
</style>